"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaidInvestmentHoldingType = void 0;
// See: https://plaid.com/docs/api/products/investments/#investments-holdings-get-response-securities-type
var PlaidInvestmentHoldingType;
(function (PlaidInvestmentHoldingType) {
    PlaidInvestmentHoldingType["cash"] = "cash";
    PlaidInvestmentHoldingType["cryptocurrency"] = "cryptocurrency";
    PlaidInvestmentHoldingType["derivative"] = "derivative";
    PlaidInvestmentHoldingType["equity"] = "equity";
    PlaidInvestmentHoldingType["etf"] = "etf";
    PlaidInvestmentHoldingType["fixedIncome"] = "fixed income";
    PlaidInvestmentHoldingType["loan"] = "loan";
    PlaidInvestmentHoldingType["mutualFund"] = "mutual fund";
    PlaidInvestmentHoldingType["other"] = "other";
})(PlaidInvestmentHoldingType || (exports.PlaidInvestmentHoldingType = PlaidInvestmentHoldingType = {}));
